import React from 'react';
import { string } from 'prop-types';

const ListsIcon = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <title>list-icon</title>
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-70 -410) translate(70 410)">
            <circle cx="20" cy="20" r="20" fill="#F2F2F2" />
            <g fill="#428A13">
              <g>
                <path
                  d="M21 4H9c-.553 0-1-.448-1-1s.447-1 1-1h12c.553 0 1 .448 1 1s-.447 1-1 1M3 0C1.343 0 0 1.343 0 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3m0 2c.552 0 1 .449 1 1 0 .551-.448 1-1 1s-1-.449-1-1c0-.551.448-1 1-1M21 12H9c-.553 0-1-.448-1-1s.447-1 1-1h12c.553 0 1 .448 1 1s-.447 1-1 1M3 8c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3m0 2c.552 0 1 .449 1 1 0 .551-.448 1-1 1s-1-.449-1-1c0-.551.448-1 1-1M21 20H9c-.553 0-1-.448-1-1s.447-1 1-1h12c.553 0 1 .448 1 1s-.447 1-1 1M3 16c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3m0 2c.552 0 1 .449 1 1 0 .551-.448 1-1 1s-1-.449-1-1c0-.551.448-1 1-1"
                  transform="translate(8 8) translate(1 1)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

ListsIcon.propTypes = {
  className: string
};

ListsIcon.defaultProps = {
  className: ''
};

export default ListsIcon;
